export const DietDaysPreviewMeal = (data: IDietDaysPreviewMeal): IDietDaysPreviewMealModel => ({
	id: data.id,
	name: LangContentToModel(data.name),
	mealType: data.meal_type,
})

export const DietDaysPreviewVariantPivot = (data: IDietDaysPreviewVariantPivot): IDietDaysPreviewVariantPivotModel => ({
	kcal: data.kcal,
	mealType: data.meal_type,
})

export const DietDaysPreviewVariant = (data: IDietDaysPreviewVariant): IDietDaysPreviewVariantModel => ({
	id: data.id,
	meal: DietDaysPreviewMeal(data.meal),
	pivot: DietDaysPreviewVariantPivot(data.pivot),
})

export const DietDaysPreview = (data: IDietDaysPreview): IDietDaysPreviewModel => {
	const { dietary_diet_id, date, published_at, meals, variants, ...rest } = data

	return {
		...rest,
		dietaryDietId: dietary_diet_id,
		date: new Date(date),
		publishedAt: published_at ? new Date(published_at) : null,
		meals: meals.map(meal => DietDaysPreviewMeal(meal)),
		variants: variants.map(DietDaysPreviewVariant),
	}
}
/**
 * Duplicate
 */
export const DietDaysDuplicateResponseResult = (
	data: IDietDaysDuplicateResponseResult,
): IDietDaysDuplicateResponseResultModel => ({
	dateTo: data.date_to ? new Date(data.date_to) : undefined,
	dateFrom: data.date_from ? new Date(data.date_from) : undefined,
	dietID: data.diet_id,
	dietName: data.diet_name ? LangContentToModel(data.diet_name) : undefined,
	message: data.message,
	status: data.status,
	menuStatus: data.menu_status,
})

export const DietDaysDuplicateResponseSummary = (
	data: IDietDaysDuplicateResponseSummary,
): IDietDaysDuplicateResponseSummaryModel => ({
	successfulCopies: data.successful_copies,
	partiallySuccessfulCopies: data.partially_successful_copies,
	totalOperations: data.total_operations,
})

export const DietDaysDuplicateResponse = (data: IDietDaysDuplicateResponse): IDietDaysDuplicateResponseModel => ({
	message: data.message,
	results: data.results.map(result => DietDaysDuplicateResponseResult(result)),
	summary: DietDaysDuplicateResponseSummary(data.summary),
})
